import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * LOADING INTERCEPTOR
 * Tracks in-flight HTTP requests so <app-global-spinner> can display.
 *
 * Opt-out: set header `X-Silent: true` on requests that should NOT
 *          trigger the spinner (background polling, SignalR heartbeats, etc.)
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loading: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isWrite = req.method !== 'GET' && req.method !== 'HEAD';
    if (isWrite) this.loading.writesInFlight++;
    const writeDone = () => { if (isWrite) this.loading.writesInFlight = Math.max(0, this.loading.writesInFlight - 1); };

    if (req.headers.has('X-Silent')) {
      // Strip the marker header before sending to server
      const stripped = req.clone({ headers: req.headers.delete('X-Silent') });
      return next.handle(stripped).pipe(finalize(writeDone));
    }

    this.loading.start();
    return next.handle(req).pipe(finalize(() => { this.loading.stop(); writeDone(); }));
  }
}
